export default __webpack_public_path__ + "images/VU.944122d.png";